import { useEffect, useState } from "react";
import HeroMarquee from "./HeroMarquee";

export default function HeroSection() {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setLoaded(true), 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section
      className="relative min-h-[100dvh] flex flex-col overflow-hidden"
      style={{ backgroundColor: "#0D0D0D" }}
    >
      {/* Background photo — full hero */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://static.readdy.ai/image/8febaa8ce715f731e0171f2e46fc1831/bac9521275498410b118a16c8cd8e17a.png"
          alt=""
          className="w-full h-full object-cover object-top"
          loading="eager"
        />
        {/* Dark overlay for text readability */}
        <div className="absolute inset-0 bg-black/60" />
        {/* Radial glow */}
        <div className="absolute inset-0 bg-hero-glow" />
      </div>

      {/* Content — left-aligned over photo */}
      <div className="relative z-10 flex-1 flex items-center justify-start">
        <div className="w-full mx-auto px-6 md:px-12 lg:px-20 text-left py-20 md:py-0">
          {/* Eyebrow */}
          <div
            className={`inline-flex items-center gap-2 px-4 py-2 rounded-full border border-gold/40 mb-8 transition-all duration-1000 ${loaded ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}
          >
            <span className="w-1.5 h-1.5 rounded-full bg-gold animate-pulse" />
            <span className="font-sans text-xs md:text-sm font-medium text-gold tracking-wider uppercase">
              Nuevo · Acceso Inmediato
            </span>
          </div>

          {/* Title */}
          <h1
            className={`font-serif font-bold text-cream mb-2 transition-all duration-1000 delay-150 animate-text-glow ${loaded ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}
          >
            <span className="block text-5xl sm:text-6xl md:text-7xl lg:text-8xl">
              Mujer
            </span>
            <span className="block text-5xl sm:text-6xl md:text-7xl lg:text-8xl animate-shimmer bg-gradient-to-r from-gold via-cream via-50% to-gold bg-clip-text text-transparent" style={{ backgroundSize: "200% auto" }}>
              Abundante
            </span>
          </h1>

          {/* Subtitle */}
          <p
            className={`font-serif text-base md:text-lg text-gold-light italic mb-6 transition-all duration-1000 delay-300 ${loaded ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}
          >
            por Anna Sauch
          </p>

          {/* Main promise */}
          <h2
            className={`font-serif text-2xl sm:text-3xl md:text-4xl lg:text-5xl text-cream leading-tight mb-4 w-full md:w-1/2 transition-all duration-1000 delay-450 ${loaded ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}
          >
            Más ingresos en 30 días con dirección, valor y oportunidades
          </h2>

          {/* Description */}
          <p
            className={`font-sans text-base md:text-lg lg:text-xl text-cream/80 max-w-lg mb-12 leading-relaxed transition-all duration-1000 delay-600 ${loaded ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}
          >
            Sin mística, sin humo. Solo habilidades, guiones, seguimiento y decisiones que generan resultados reales.
          </p>

          {/* CTA */}
          <a
            href="#pricing"
            className={`inline-flex items-center justify-center gap-3 px-8 py-4 md:px-10 md:py-5 rounded-md font-sans font-semibold text-base md:text-lg text-white transition-all duration-300 hover:scale-[1.02] hover:brightness-110 ${loaded ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}
            style={{
              backgroundColor: "#2E7D32",
              transitionDelay: loaded ? "750ms" : "0ms",
            }}
          >
            <span>Quiero acceso ahora</span>
            <i className="ri-arrow-right-line text-lg" />
          </a>

          {/* Sub CTA */}
          <p
            className={`mt-8 font-sans text-sm md:text-base text-cream/80 transition-all duration-1000 delay-900 ${loaded ? "opacity-100" : "opacity-0"}`}
          >
            Solo USD $19 · Valor real: $47 · 7 días de garantía
          </p>
        </div>
      </div>

      {/* Bottom divider + marquee */}
      <div className="relative z-10">
        <div className="h-px bg-gold-gradient" />
        <HeroMarquee />
      </div>
    </section>
  );
}